module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_donation02-960a824c7c12969ab0f9a51a53f84024.jpg";